import React, { Component } from 'react';
import { connect } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { withStyles } from '../../mui-styles-bridge.js';
import RawText from '../component/RawText';
import '../Form.css';
//components
import Multiplechoice from '../component/Multiplechoice';
import Freetext from '../component/Freetext';
import ListInput from '../component/ListInput';
import SingleLinetext from '../component/SingleLinetext';
import Singlechoice from '../component/Singlechoice';
import SingleSelect from '../component/SingleSelect';
import NumberInput from '../component/NumberInput';
import CustomMap from '../component/Map';
import Calendar from '../component/Calendar';
import UploadMedia from '../component/UploadMedia';
import ImageAnnotation from '../component/ImageAnnotation';
import Address from '../component/Address';
import { answerDecoder } from '../form_tools/answerEncoderDecoder';
import FadeIn from '../../components/FadeIn';

import {
  dynamicRender,
  createDefaultCondition,
  v2ConditionsToV1Statement,
} from '../form_tools/dynamicRender';
import { parseJson } from '../form_tools/extraFunction';
import Comment from '../component/Comment';
import { addPageData } from '../../store/form/actions';

// styles
import { styles } from '../form_tools/formStyle';
var _ = require('lodash');

class FormPreviewPage extends Component {
  componentSelector = (format, data, section) => {
    switch (format) {
      case 'checkbox':  // v2
      case 'multiple_choice':
        return data.drop_down == 'true' ? (
          <Accordion>
            <AccordionSummary key={data.key} expandIcon={<ExpandMoreIcon />}>
              <Typography>{data.key}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Multiplechoice
                key={data.key}
                getDataFromComponent={this.getDataFromComponent}
                data={data}
              />
            </AccordionDetails>
          </Accordion>
        ) : (
          <Multiplechoice
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'long_text':  // v2
      case 'free_text':
        return (
          <Freetext
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'short_text':  // v2
      case 'single_line_text':
        return (
          <SingleLinetext
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'radio_button':  // v2
      case 'single_choice':
        return data.drop_down == 'true' ? (
          <Accordion>
            <AccordionSummary key={data.key} expandIcon={<ExpandMoreIcon />}>
              <Typography>{data.key}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Singlechoice
                key={data.key}
                getDataFromComponent={this.getDataFromComponent}
                data={data}
              />
            </AccordionDetails>
          </Accordion>
        ) : (
          <Singlechoice
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'number':  // v2
      case 'number_input':
        return (
          <NumberInput
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'map':  // v2
      case 'custom_map':
        return (
          <CustomMap
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'date':  // v2
      case 'calendar':
        return (
          <Calendar
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'row_text':
        if (section == 'title') {
          return (
            <div>
              <h2>{data.data}</h2>
            </div>
          );
        } else if (section == 'answer') {
          return <RawText data={data} />;
        } else if (section == 'subtitle')
          return (
            <div className={'renderBreadCrumsDiv'}>
              <p className={'renderBreadCrumsPtag'}>data.data</p>
            </div>
          );
        else return <div>{data.data}</div>;
      case 'dropdown':  // v2
      case 'single_select':
        return (
          <SingleSelect
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'file_upload':  // v2
      case 'upload_media':
        return (
          <UploadMedia
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'list':  // v2
      case 'list_input':
        return (
          <ListInput
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'image_annotation':
        return (
          <ImageAnnotation
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      case 'address':
        return (
          <Address
            key={data.key}
            getDataFromComponent={this.getDataFromComponent}
            data={data}
          />
        );
      default:
        return section == 'title' ? (
          <div style={{ textAlign: 'left', borderBottom: '1px solid black' }}>
            <h4>{data.data}</h4>
          </div>
        ) : (
          <div style={{ textAlign: 'left' }}>
            <p>{data.data}</p>
          </div>
        );
    }
  };
  isContain = (data, container) => {
    function hasObject(element, target) {
      return _.isEqual(element, target);
    }
    let i = undefined;

    container.forEach((n) => {
      let a = hasObject(n, data);
      if (a == true) {
        i = n;
      }
      if (Array.isArray(n)) {
        if (data == n[0]) {
          i = n;
        }
      }
    });
    return i;
  };
  getDataFromComponent = (data, key, question_text, answer_list) => {
    data = answerDecoder(data, answer_list);
    this.props.dispatchaddPageData(key, data, question_text);
  };
  render() {
    const { form, classes, required_list } = this.props;
    const { current_index, form_length, request_data, answer_data } = form;
    console.log(answer_data);

    const page_data = request_data[current_index];
    let titleComponent = null;
    let subtitleComponent = null;
    if (page_data) {
      // v2: page_data.title is a string; v1: page_data.title.view.data.default
      const pageTitleText =
        (typeof page_data.title === 'string' ? page_data.title : null) ||
        page_data.title?.view?.data?.default;

      titleComponent = this.componentSelector(
        page_data.title?.view?.format || 'row_text',
        {
          data: dynamicRender(
            this,
            pageTitleText,
            page_data.title?.view?.data?.dynamic
          ),
          style: page_data.title?.view?.style,
        },
        'title'
      );
      subtitleComponent = this.componentSelector(
        page_data.title?.view?.format || 'row_text',
        {
          data: dynamicRender(
            this,
            pageTitleText,
            page_data.title?.view?.data?.dynamic
          ),
          style: page_data.title?.view?.style,
        },
        'subtitle'
      );
    }
    return (
      <>
        <React.Fragment>
          <div className={'divRender'}>{subtitleComponent}</div>
          <div style={{ textAlign: 'left' }} id="title-area">
            <FadeIn>
              {titleComponent}
              {page_data &&
                (page_data.components || page_data.fields || []).map((n) => {
                  let auto;
                  const fieldType = n.type || n.views?.answer?.view?.format;
                  let v2Field = n.type && !n.views;
                  if (v2Field) {
                    if (n.visible && n.visible.conditions) {
                      n = { ...n, visibility: v2ConditionsToV1Statement(n.visible) };
                    }
                    if (n.required && n.required.conditions) {
                      n = { ...n, required: v2ConditionsToV1Statement(n.required) };
                    }
                    if (n.readOnly && n.readOnly.conditions) {
                      n = { ...n, read_only: v2ConditionsToV1Statement(n.readOnly), readOnly: undefined };
                    }
                    if (n.prefill && typeof n.prefill === 'object' && n.prefill.conditions) {
                      n = { ...n, auto: v2ConditionsToV1Statement(n.prefill), prefill: undefined };
                    }
                  }
                  const questionText = v2Field
                    ? (n.label !== undefined ? n.label : '')
                    : (n.label || n.views?.question?.view?.data?.default);
                  const description = n.description || n.views?.question?.description?.default;

                  let answer_list;
                  let question_list;

                  const normalizeV2Cols = (cols) => {
                    if (!Array.isArray(cols)) return cols;
                    return cols.map(c => ({
                      ...c,
                      columnName: c.columnName || c.label || '',
                      id: c.id || c.key || '',
                      question: c.question || c.label || '',
                    }));
                  };
                  if (v2Field) {
                    if (fieldType === 'table' || fieldType === 'repeatable_section') {
                      answer_list = normalizeV2Cols(n.columns || n.fields || []);
                    } else {
                      answer_list = n.options || '';
                    }
                    question_list = questionText;
                  } else {
                    answer_list = parseJson(
                      dynamicRender(
                        this,
                        n.views?.answer?.view?.data?.default,
                        n.views?.answer?.view?.data?.dynamic
                      )
                    );
                    question_list = parseJson(
                      dynamicRender(
                        this,
                        questionText,
                        n.views?.question?.view?.data?.dynamic
                      )
                    );
                  }

                  // v2 uses n.visible (boolean); v1 uses n.visibility (dynamic condition)
                  let visible;
                  if (n.visibility !== undefined && n.visibility !== null) {
                    createDefaultCondition(n.visibility);
                    visible = dynamicRender(this, '', n.visibility) + '';
                  } else {
                    visible = n.visible === false ? 'false' : 'true';
                  }
                  auto = (v2Field && !n.auto)
                    ? (n.prefill || '')
                    : parseJson(dynamicRender(this, '', n.auto));
                  if (auto != '') {
                    if (
                      fieldType == 'multiple_choice' || fieldType == 'checkbox' ||
                      fieldType == 'single_choice' || fieldType == 'radio_button' ||
                      fieldType == 'single_select' || fieldType == 'dropdown'
                    ) {
                      // Validate that the auto value exists in the answer list
                      let answer = this.isContain(auto, answer_list);

                      if (!answer) {
                        // Clear invalid prefill value
                        auto = '';
                      } else {
                        // For single_select, format auto as array [null, value]
                        if (fieldType == 'single_select' || fieldType == 'dropdown') {
                          // Extract the value from the answer array (answer[1] contains the display value)
                          const value = Array.isArray(answer)
                            ? answer[1]
                            : answer;
                          auto = [null, value];
                        } else {
                          // For multiple_choice and single_choice, use the matched answer
                          auto = answer;
                        }
                      }
                    } else if (typeof answer_list != 'object') {
                      answer_list = auto;
                    }
                  }
                  let readonly = (v2Field && !n.read_only)
                    ? (n.readOnly === true ? 'true' : 'false')
                    : dynamicRender(this, 'false', n.read_only) + '';
                  console.log({
                    n,
                    auto,
                    visible,
                    answer_list,
                    question_list,
                  });
                  return (
                    <div
                      style={{
                        display:
                          visible == 'false'
                            ? 'none'
                            : visible == ''
                              ? 'none'
                              : '',
                      }}
                    >
                      {required_list &&
                        required_list.length > 0 &&
                        required_list.lastIndexOf(n.key) != -1 && (
                          <div
                            style={{
                              marginTop: 12,
                              height: 30,
                              backgroundColor: 'rgba(176, 0, 32, 0.1)',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <i
                              style={{ marginRight: 24 }}
                              className="material-icons error"
                            >
                              error
                            </i>
                            <p className={'error'}>This question is required</p>
                          </div>
                        )}
                      {fieldType != 'row_text' && (
                        <div style={{ marginTop: '32px' }} id="question-area">
                          {this.componentSelector(
                            n.views?.question?.view?.format || 'row_text',
                            {
                              data: question_list || '',
                              style: v2Field ? undefined : parseJson(n.views?.question?.style),
                            },
                            'question'
                          )}
                          <p
                            style={{
                              textAlign: 'left',
                              margin: 'auto',
                              color: '#868686',
                            }}
                          >
                            {v2Field
                              ? (description || '')
                              : dynamicRender(
                                  this,
                                  description,
                                  n.views?.question?.description?.dynamic
                                )}
                          </p>
                        </div>
                      )}

                      <div
                        style={{ marginTop: '20px', textAlign: 'left' }}
                        id="answer-area"
                      >
                        {this.componentSelector(
                          fieldType,
                          {
                            data: fieldType === 'file_preview'
                              ? (n.fileUrl || n.rte_answer_data_default || n.views?.answer?.view?.data?.default || answer_list || '')
                              : (answer_list != null ? answer_list : ''),
                            style: v2Field ? undefined : parseJson(n.views?.answer?.style),
                            key: n.key,
                            read_only: JSON.parse(readonly),
                            list_min: n.minItems ?? n.list_min,
                            list_max: n.maxItems ?? n.list_max,
                            file_type: n.file_type ?? n.fileType,
                            auto: auto,
                            question_text: question_list,
                            drop_down: n.drop_down,
                            annotationSourceMode: n.annotationSourceMode,
                            presetImageUrl: n.presetImageUrl,
                            addressFieldConfig: n.addressFields || n.addressFieldConfig,
                          },
                          'answer'
                        )}
                        <div>
                          {n.comment && (
                            <Comment
                              key={n.key}
                              format={fieldType}
                              question_text={question_list}
                              keyComponent={n.key}
                            />
                          )}
                        </div>
                        <p
                          style={{
                            textAlign: 'left',
                            margin: 'auto',
                            color: '#868686',
                          }}
                        >
                          {v2Field
                            ? ''
                            : dynamicRender(
                                this,
                                n.views?.answer?.description?.default,
                                n.views?.answer?.description?.dynamic
                              )}
                        </p>
                      </div>
                      <div style={{ height: '2vh' }}></div>
                      <Divider />
                    </div>
                  );
                })}
            </FadeIn>
          </div>
        </React.Fragment>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {
  dispatchaddPageData: (key, answer, question_text) =>
    addPageData({ key, answer, question_text }),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(FormPreviewPage));
